import { Cached, Groups, ManageAccounts, MonitorHeart, PlayArrow } from "@mui/icons-material";
import React, { useCallback } from "react";
import { Routing } from "../../data/Constants/Routing";
import MenuBar from "../Menu/MenuBar";
import MenuNavButton from "../Menu/MenuNavButton";
import MenuLogo from "../Menu/MenuLogo";
import logo from "../../data/resources/logo.png";
import MenuButton from "../Menu/MenuButton";
import useDialog from "../Hooks/Dialog/useDialog";
import { reloadAllState, useAppDispatch } from "../../state/Store";
import ConfirmationDialog from "../Hooks/Dialog/ConfirmationDialog";
import { ControllerAPI } from "../../api/api";
import { hasFailed } from "@miragon/react-utils-api";
import useSnackbar from "../Hooks/Snackbar/useSnackbar";

const Menu: React.FC = () => {
    const dialog = useDialog();
    const snackbar = useSnackbar();
    const dispatch = useAppDispatch();

    const onClearCache = useCallback(async () => {
        const confirmation = await dialog.open(ConfirmationDialog, {
            title: "Cache leeren",
            question: "Wollen Sie den Cache wirklich leeren?",
            acceptButtonTitle: "Leeren"
        });
        if (!confirmation.accepted) {
            return;
        }

        const response = await ControllerAPI.clearCache();
        if (hasFailed(response)) {
            snackbar.onApiError(response);
        } else {
            snackbar.onSuccess("Cache geleert.");
            reloadAllState(dispatch);
        }
    }, [dialog, dispatch, snackbar]);

    return (
        <MenuBar>

            <MenuLogo src={logo} />

            <MenuNavButton
                target={Routing.Administration.Worker.Navigate()}
                icon={MonitorHeart}
                label="Workers" />

            <MenuNavButton
                target={Routing.Administration.Execution.Navigate()}
                icon={PlayArrow}
                label="Ausführungen" />

            <MenuNavButton
                target={Routing.Administration.Scenario.Navigate()}
                icon={Groups}
                label="Szenarien" />

            <MenuNavButton
                target={Routing.Administration.Role.Navigate()}
                icon={ManageAccounts}
                label="Rollen" />

            <MenuButton
                icon={Cached}
                onClick={onClearCache}
                label="Cache leeren" />

        </MenuBar>
    );
};

export default Menu;
